/**
 * OFFGRD bundle tiers → product form quantity.
 *
 * Progressive enhancement: without JS the tiers still render and read as a
 * price table, and the normal quantity input continues to work.
 */
(function () {
  'use strict';

  function findQtyInput(bundle) {
    // The form is not always a direct ancestor, so fall back to the page-level
    // product form quantity input.
    var form = bundle.closest('form[action*="/cart/add"]');
    if (form) {
      var inForm = form.querySelector('input[name="quantity"]');
      if (inForm) return inForm;
    }
    return document.querySelector(
      '.product-form__quantity, input.product-form__input[name="quantity"], input[name="quantity"]'
    );
  }

  document.addEventListener('click', function (e) {
    var tier = e.target.closest && e.target.closest('.offgrd-tier');
    if (!tier) return;

    var bundle = tier.closest('[data-offgrd-bundle]');
    if (!bundle) return;

    e.preventDefault();

    var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;

    bundle.querySelectorAll('.offgrd-tier').forEach(function (t) {
      var on = t === tier;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    var input = findQtyInput(bundle);
    if (input) {
      input.value = String(qty);
      // Themes commonly listen for change/input to sync their own quantity UI.
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var note = bundle.querySelector('[data-offgrd-note]');
    var out = bundle.querySelector('[data-offgrd-qty]');
    if (note && out) {
      out.textContent = String(qty);
      note.hidden = qty < 2;
    }
  });
})();
